import type * as React from 'react';
import type { FC } from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { TextLink } from '@crehana/ui';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Link as RouterLink } from 'react-router-dom';

const Link: FC<
  React.PropsWithChildren<{ href?: string; label?: string; navLink?: string }>
> = ({ href, label, navLink }) =>
  navLink ? (
    <RouterLink to={navLink}>
      <TextLink label={label || href} type="body3" />
    </RouterLink>
  ) : (
    <TextLink
      href={href && href.includes('@') ? `mailto:${href}` : href}
      label={label || href}
      type="body3"
    />
  );

export default Link;
